const timeoffKeys = {
  availableTimeoff: ["availableTimeoff"],
};

export default timeoffKeys;
